import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import measurement from "./components/measurement";
import torso from "./components/torso";
import head from "./components/head";
import pinna from "./components/pinna";

const principle: Slide = {
  description: "Different anatomical features influence the sound propagation in distinct frequency regions.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Measurement Microphone" },
            { name: "Torso & Shoulders" },
            { name: "Head, Cavum conchae & Ear Canal" },
            { name: "Pinna" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [measurement, torso, head, pinna],
    },
  },
};

export default principle;
